import { Component } from '@angular/core';
import { AbstractDepartmentTemplateComponent } from './abstract-department-template-component.directive';
import { CargoGearForm } from '../../../../../department/forms/vessel-cargo-gear.form';

@Component({
  selector: 'app-cargo-gear-template',
  templateUrl: './cargo-gear-template.component.html',
  standalone: false,
})
export class CargoGearTemplateComponent extends AbstractDepartmentTemplateComponent<CargoGearForm> {}
